import { FC } from 'react';
import { useState } from '@hookstate/core';
import { useBackgroundSounds } from '../../hooks/use-background-sounds';
import {
    current,
    calls,
    meta,
    winners,
    fireBallStatus,
} from '../../stores/backend';

export const BackgroundSounds: FC = () => {
    const $game = useState(current);
    const $calls = useState(calls);
    const $meta = useState(meta);
    const $winners = useState(winners);
    const $fireBallStatus = useState(fireBallStatus);

    useBackgroundSounds($game, $calls, $meta, $winners, $fireBallStatus);

    return <></>;
};
